import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export const UNAUTHORIZED_ROUTE_REQUESTED_URL_QUERY_PARAM = 'requestedUrl';

@Injectable({ providedIn: 'root' })
export class UnauthorizedService {
  constructor(private readonly router: Router) {}

  navigateToUnauthorizedRoute(requestedUrl: string) {
    return this.router.navigate(['/unauthorized'], {
      queryParams: {
        [UNAUTHORIZED_ROUTE_REQUESTED_URL_QUERY_PARAM]: requestedUrl,
      },
    });
  }
}
